import $ from 'jquery';

/**
 * Defines the className of the dot button
 * @type {string}
 */
export const DOT_CLASS = 'image-carousel__dot-button';
//
/**
 * Allows us to customize the "dot buttons"
 * @param {jQuery} $slides - slick slides (from slick)
 * @param {number} i - iterator, used to select current slide from $slides
 * @see DEFAULT_OPTIONS
 * @return {jQuery} "dot button"
 */

 const updateCounterMarkup = (e, slick, $el) => {
   $el.find('.slides__status').html(slick.currentSlide + 1 +' / '+slick.slideCount);
 };

 const counterMarkup = (e, slick, $el) => {
   var $slidesStatusWrap = $el.find('.slides__status-wrap');
   $slidesStatusWrap.append('<div class="slides__status">'+ parseInt(slick.currentSlide + 1, 10) +' / '+ slick.slideCount +'</div>');
 };

export default function createCounter($el) {
  $el.on('init', function(e, slick) {
    counterMarkup(e, slick, $el);
  });
  $el.on('afterChange', function(e, slick) {
    updateCounterMarkup(e, slick, $el)
  });
}



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/slick/counter.js